
import api from '../../services/service'

export default {
  data () {
    return {
      data_list: [],
      header: {
        'Access-Token': this.$store.state.token
      }
    }
  },
  methods: {
    setHostShift (data) {
      this.getListHostDetail(data)
      $('#HostList').modal('hide')
    },
    getListHost () {
      api.getHostShift(this.REST_URL,
        this.header,
        result => {
          if (result.response === 'success') {
            this.data_list = result.data
          } else {
            this.$notification['warning']({
              message: 'ดึงข้อมูลจุดขายไม่ได้',
              description: result.message
            })
          }
        },
        _error => {
          this.$notification['warning']({
            message: 'เชื่อมไม่สำเร็จ'
          })
          // alert('ไม่สามารถเข้าถึงข้อมูล ' + JSON.stringify(error))
        }
      )
    }
  },
  mounted () {
    this.getListHost()
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/hostlist.js